  <template>
    <div>
      <app-header></app-header>
      <div :class="isLogin?'mt-70':''">
        <v-container grid-list-xl pt-0>
          <v-layout row wrap>
            <v-flex xs12 md12 lg12 sm12 class="col-height-auto">
              <v-layout row wrap justify-center align-center>
                <!-- - - - - - - - - - - -  POST - - - - - - - - - - - -  -->
              <v-flex xs12 md7 lg8>
                <div>
                 <v-card class="mb-4" v-for="(post, index) in postSearchList" :key="index">
                  <div class="media-listing">
                    <ul class="list-unstyled">
                      <li class="media">
                        <div v-for="(user, index) in userDetailSearchList" v-if="post.postingUserId == user.userId" :key="index" class="ml-2 mr-2 pt-3">
                          <!-- <span @click="goUserData(user.userName)" class="pointer user-avatar">
                          <img class="img-responsive rounded-circle posting-img" :src="user.image">
                        </span> -->
                          <div class="mb-3">
                            <v-avatar color="primary" class="pointer" size="32" @click="goUserData(user.userName)">
                              <img v-show="user.image != null" :src="user.image" :alt="user.userName" />
                              <span v-show="user.image == null" class="headline white--text">
                                {{
                                  user.userName
                                    .trim()
                                    .substring(0, 1)
                                    .toLocaleUpperCase()
                                }}
                              </span>
                            </v-avatar>
                            <span @click="goUserData(user.userName)" class="pl-2 pointer hover-color font-16 fw-700">
                              {{ user.nickName }}
                              <span>({{ user.reputationScore }})</span>
                            </span>
                            <span class="px-2 fw-500 font-14">
                              <v-icon size="18">schedule</v-icon>
                              {{ dateFormat(post.postingTime) }}
                            </span>
                          </div>

                          <div class="row">
                            <div v-for="(user, index) in userDetailSearchList" v-if="post.postingUserId == user.userId" :key="index" class="px-0">
                              <span
                                v-if="post.postingImg != ''"
                                v-html="post.postingImg"
                                @click="findsel(post)"
                                class="rounded-circle mr-4 img-responsive posts-image pointer"
                              ></span>
                            </div>
                            <div class="media-body">
                              <h3 class="fw-700 pointer break-word" @click="findsel(post)" v-html="post.postingTitle"></h3><!-- {{ post.postingTitle }} -->
                              <h5 class="mb-3 py-2" v-html="post.postingContent" @click="findsel(post)"></h5>
                              <div class="mt-1 justify-space-between">
                                <div class="social">
                                  <span class="pointer">
                                    <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                    <span class="font-1x fw-400 ml-1">{{ post.bonus.toFixed(2) }}</span>
                                  </span>
                                  <span v-if="post.postingStatus == 0" class="ml-2">
                                    <v-icon @click="changesup(post)" small color="primary" :title="$t('posting.upvote')">thumb_up</v-icon>
                                    <span class="font-14 fw-400 ml-1">{{ post.postingGoodnums }}</span>
                                    <v-icon @click="changesdown(post)" small class="ml-2" :title="$t('postingsel.tread')">thumb_down</v-icon>
                                    <span class="font-14 fw-400 ml-1">{{ post.postingStepnums }}</span>
                                  </span>
                                  <span v-if="post.postingStatus == 1" class="ml-2">
                                    <v-icon @click="changesup(post)" small :title="$t('posting.upvote')">thumb_up</v-icon>
                                    <span class="font-14 fw-400 ml-1">{{ post.postingGoodnums }}</span>
                                    <v-icon @click="changesdown(post)" class="ml-2" small color="primary" :title="$t('postingsel.tread')">thumb_down</v-icon>
                                    <span class="font-14 fw-400 ml-1">{{ post.postingStepnums }}</span>
                                  </span>
                                  <span v-if="post.postingStatus == -1" class="ml-2">
                                    <v-icon small @click="changesup(post)" :title="$t('posting.upvote')">thumb_up</v-icon>
                                    <span class="font-14 fw-400 ml-1">{{ post.postingGoodnums }}</span>
                                    <v-icon @click="changesdown(post)" class="ml-2" small :title="$t('postingsel.tread')">thumb_down</v-icon>
                                    <span class="font-14 fw-400 ml-1">{{ post.postingStepnums }}</span>
                                  </span>
                                  <span class="ml-2">
                                    <v-icon @click="findsel(post)" small :title="$t('posting.comment')">fa fa-comment</v-icon>
                                    <span class="font-14 fw-400 ml-1">{{ post.postingCountComments }}</span>
                                  </span>
                                  <span class="ml-2" v-for="(user, index) in userDetailSearchList" v-if="post.postingUserId == user.userId">
                                    <v-icon @click="modalzf(post, user)" small :title="$t('posting.retweet')">fa fa-share</v-icon>
                                    <span class="font-14 fw-400 ml-1">{{ post.postingCountForword }}</span>
                                  </span>
                                  <span class="ml-2">
                                    <v-icon v-if="post.postingCollection == 0" @click="collectionPosting(post)" small color="primary" :title="$t('posting.save')">
                                      fa fa-star
                                    </v-icon>
                                  </span>
                                  <span><v-icon v-if="post.postingCollection != 0" @click="collectionPosting(post)" small :title="$t('posting.save')">fa fa-star</v-icon></span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                   </ul>
                  </div>
                </v-card>
                <!--infinite-loading这个组件要放在列表的底部，滚动的盒子里面！-->
                <infinite-loading :identifier="infiniteId" @infinite="getPostSearchList" class="mb-3">
                  <div slot="spinner">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>
                  <div slot="no-more">{{$t("posting.noMore")}}</div>
                  <div slot="no-results">{{$t("posting.noResults")}}</div>
                </infinite-loading>
                </div>
                <!--转发模态窗-->
                <v-dialog v-model="forwardModal" persistent max-width="600px">
                  <v-card>
                    <v-card-title>
                      <span class="font-30 fw-500">{{ $t('posting.retweet') }}</span>
                    </v-card-title>
                    <v-list two-line>
                      <v-list-tile>
                        <v-list-tile-avatar>
                          <!-- <span @click="goUserData(postUserName)" class="pointer user-avatar">
                              <img class="img-responsive rounded-circle posting-img" :src="postUserImage">
                            </span> -->
                          <v-avatar color="primary" class="pointer" size="32" @click="goUserData(postUserName)">
                            <img v-show="postUserImage != null" :src="postUserImage" :alt="postUserName" />
                            <span v-show="postUserImage == null" class="headline white--text">
                              {{
                                postUserName
                                  .trim()
                                  .substring(0, 1)
                                  .toLocaleUpperCase()
                              }}
                            </span>
                          </v-avatar>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <span @click="goUserData(postUserName)" class="pointer font-18 fw-700">{{ postNickName }}</span>
                            <span class="px-2 font-16 fw-700">
                              {{ $t('common.at') }}
                              <v-icon size="18">schedule</v-icon>
                              {{ dateFormat(postDate) }}
                            </span>
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            <span class="font-14 fw-700">{{ postTitle }}</span>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md12>
                            <v-form ref="formValidatezf"><v-textarea solo name="input-7-4" v-model="formValidatezf.postingForwardContext"></v-textarea></v-form>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="primary" flat @click="forwardModal = false">Close</v-btn>
                      <v-btn class="primary" flat @click="postingforward">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>
  </template>
  <style>
  </style>
  <script>
  import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import config from '../../config.js'
  import InfiniteLoading from 'vue-infinite-loading';
  export default {
    data() {
      return {
        infiniteId: +new Date(),
        isLoadingSearchList: false, // 是否正在加载按热度排序的集合
        searchListPageNo: 0, // 按热度排序集合的页码
        pageSize: 10, // 每次查询几条数据
        postSearchList: [], // 帖子集合
        userDetailSearchList: [], // 发帖用户集合
        postingIds: [], // 需要查询操作的帖子ID集合
        forwardModal: false, // 转发按钮
        postUserImage: '', //作者的头像
        postTitle: '', //帖子标题
        postDate: '', //发帖日期
        postNickName: '', //作者昵称
        postUserName: '', //作者用户名
        formValidatezf: { // 转发帖子的对象
          postingUserforwardId: this.$store.state.user.id,
          postingId: '',
          postingForwardContext: ''
        },
        formCollection: { // 收藏帖子表单
          userId: '',
          postingId: '',
        }
      }
    },
    created() {

    },
    computed: {
      ...mapGetters(["user"]),
      searchText() {
        return this.$store.getters.searchText;
      },
      isLogin() {
        if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
          return true;
        } else {
          return false;
        }
      }
    },
    mounted() {
      this.$store.dispatch('searchTextHandler', this.$route.params.searchText);
      this.reloadData();
    },
    watch: {
      searchText(newVal, oldVal) {
        if (newVal != null && newVal.trim() != '') {
          this.searchListPageNo = 0;
          this.postSearchList = [];
          this.userDetailSearchList = [];
          this.infiniteId += 1;
        }
      }
    },
    components: {
      InfiniteLoading,
    },
    methods: {
      // 重新加载数据
        reloadData(){
          this.searchListPageNo = 0;
          this.postSearchList = [];
          this.userDetailSearchList = [];
          this.infiniteId += 1;
        },
      // 搜索
      getPostSearchList($state) {
        if (this.isLoadingSearchList) {
          return;
        }
        let url = null;
        if (this.searchText != null && this.searchText.trim() != '') {
          // url = config.baseUrl + "solr/open/searchPost/" + this.searchListPageNo + "/" +
          url = config.baseUrl + "es/open/searchPost/" + this.searchListPageNo + "/" +
            this.pageSize + "/" + this.searchText;
        } else {
          return;
        }
        this.isLoadingSearchList = true;
        this.$http.get(url).then(response => {
          let data = response.data;
          if (data.resCode == 0) {
            this.searchListPageNo += 1;
            this.postSearchList = [...this.postSearchList, ...data.result.postList];
            if (localStorage.getItem('token')) {
              // 加载操作信息
              this.getUserActions(data.result.postList);
            }
            let udList = data.result.userDetailList;
            let upList = data.result.userpopularsList;
            //如果新查询出来的UserDetail与集合中的重复，就将其删除
            for (let i = 0; i < this.userDetailSearchList.length; i++) {
              for (let j = 0; j < udList.length; j++) {
                if (this.userDetailSearchList[i].userId == udList[j].userId) {
                  //删除数组中的这个对象
                  udList.splice(j, 1);
                }
              }
            }
            this.userDetailSearchList = [...this.userDetailSearchList, ...udList];
            this.isLoadingSearchList = false;
            $state.loaded();
          } else {
            this.isLoadingSearchList = false;
            $state.complete();
          }
        });
      },
      // 用户登录后根据帖子集合加载操作信息
      getUserActions(postList) {
        if (!localStorage.getItem('token')) {
          return;
        }
        for (let i = 0; i < postList.length; i++) {
          this.postingIds[i] = postList[i].postingId;
        }
        //查询用户是否对帖子点赞点踩
        let url = config.baseUrl + "posting/UserEvalutiongood/" + this.$store.state.user.id;
        this.$http.post(url, this.postingIds).then((successData) => {
          let voteList = successData.data.result;
          for (let i = 0; i < postList.length; i++) {
            for (let j = 0; j < voteList.length; j++) {
              if (postList[i].postingId == voteList[j].postingId) {
                if (voteList[j].eStatus == '0') {
                  postList[i].postingStatus = 0;
                }
                if (voteList[j].eStatus == '1') {
                  postList[i].postingStatus = 1;
                }
              }
            }
          }
        });
        //查询用户是否对帖子进行收藏
        let collectionUrl = config.baseUrl + "collection/getCollectionByUserIdAndPostingIds/" + this.$store.state.user.id;
        this.$http.post(collectionUrl, this.postingIds).then(successData => {
          let data = successData.data;
          if (data.resCode == 0) {
            let collectionList = data.result;
            //存在数据，需要变色
            for (let i = 0; i < postList.length; i++) {
              for (let j = 0; j < collectionList.length; j++) {
                if (postList[i].postingId == collectionList[j].postingId) {
                  postList[i].postingCollection = 0;
                }
              }
            }
          }
        });
      },
      // 路由到查看用户详情页面
      goUserData(username) {
        this.$router.push({
          name: 'userData',
          params: {
            username: '@' + username
          }
        });
      },
      // 点赞帖子
      changesup(obj) {
        if (localStorage.getItem('token')) {
          let url = config.baseUrl + "posting/evaluationgood/" + obj.postingId;
          this.$http.get(url).then(function(successData) {
            let that = this;
            let data = successData.data;
            if (data.resCode == 0) {
              //在页面给点赞数加1
              obj.postingGoodnums = data.result;
              obj.postingStatus = 0;
            } else if (data.resCode == -11) {
              this.$Message.warning({
                content: this.$t('posting.evaluation'),
                duration: 2
              });
            } else if (data.resCode == -1) {
              this.$Message.warning({
                content: this.$t('posting.evaluation'),
                duration: 2
              });
            }
          });
        } else {
          this.$store.state.loginModal = true;
        }
      },
      // 踩帖子
      changesdown(obj) {
        if (localStorage.getItem('token')) {
          let url = config.baseUrl + "posting/evaluationstep/" + obj.postingId;
          this.$http.get(url).then(function(successData) {
            let that = this;
            let data = successData.data;
            if (data.resCode == 0) {
              //在页面给点踩数加1
              obj.postingStepnums = data.result;
              obj.postingStatus = 1;
            } else if (data.resCode == -1) {
              this.$Message.warning({
                content: this.$t("posting.evaluation"),
                duration: 1
              });
            } else if (data.resCode == -11) {
              this.$Message.warning({
                content: this.$t("posting.evaluation"),
                duration: 1
              });
            }
          });
        } else {
          this.$store.state.loginModal = true;
        }
      },
      // 转发
      postingforward() {
        let url = config.baseUrl + "posting/forward";
        this.$http.post(url, this.formValidatezf).then(successData => {
          let data = successData.data;
          this.forwardModal = false;
          if (data.resCode == 0) {
            this.$Message.success({
              content: this.$t('posting.forwardMessage'),
              duration: 2
            });
            this.formValidatezf.postingForwardContext = '';
            this.formValidatezf.postingId = '';
            for (var i = 0; i < this.postList.length; i++) {
              if (this.postList[i].postingId == this.formValidatezf.postingId) {
                this.postList[i].postingCountForword = data.result;
                break;
              }
            }
          } else if (data.resCode == -1) {
            this.$Message.error({
              content: this.$t('common.fail'),
              duration: 2
            });
          }
        }, error => {
          this.forwardModal = false;
        });
      },
      //点击转发弹出转发框
      modalzf(obj, user) {
        if (localStorage.getItem('token')) {
          this.formValidatezf.postingId = obj.postingId;
          this.formValidatezf.postingForwardContext = '';
          this.postUserImage = user.image; //头像
          this.postTitle = obj.postingTitle; //帖子标题
          this.postDate = obj.postingTime; //发帖日期
          this.postUserName = user.userName; //用户名
          this.postNickName = user.nickName; //昵称
          this.forwardModal = true;
        } else {
          this.$store.state.loginModal = true;
        }
      },
      //  关闭转发框
      postingforwardCancel() {
        this.forwardModal = false;
      },
      // 收藏帖子
      collectionPosting(posting) {
        if (!localStorage.getItem('token')) {
          this.$store.state.loginModal = true;
          return;
        }
        this.formCollection.userId = this.$store.state.user.id;
        this.formCollection.postingId = posting.postingId;
        this.$http.post(config.baseUrl + "collection/saveCollectionPosting", this.formCollection).then((successData) => {
          let data = successData.data;
          if (data.resCode == 0) {
            posting.postingCollection = 0;
          } else if (data.resCode == 1) {
            posting.postingCollection = -1;
          }
        });
      },
      //根据id跳转到帖子详情
      findsel(posting) {
        this.$router.push({
          name: 'postingsel',
          params: {
            postingId: posting.postingId,
            username: posting.postingUserName

          }
        });
      },
      //格式化时间
      dateFormat(time) {
        let timeOffset = -28800000;
        if (this.user) {
          timeOffset = this.user.timeOffset;
        }
        return formatDate(time, timeOffset, this.$i18n.locale);
      },
    },
  }

  </script>



// WEBPACK FOOTER //
// SearchPosts.vue?64d52819